import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import BTCIcon from '../../../../../static/svg/btc-icon.svg';
import LTCIcon from '../../../../../static/svg/ltc-icon.svg';
import ETHIcon from '../../../../../static/svg/eth-icon.svg';
import XMRIcon from '../../../../../static/svg/xmr-icon.svg';
import XRPIcon from '../../../../../static/svg/xrp-icon.svg';
import EOSIcon from '../../../../../static/svg/eos-icon.svg';

import './DisplayBox.scss';

const DisplayBox = ({ coin }) => {
  const formatPrice = price => {
    const decimalIndex = price.indexOf('.');
    return price.substring(0, decimalIndex + 3);
  };

  const formatDate = timestamp => {
    const date = moment.unix(timestamp);
    const formatted = date.format('M/D/YY');
    return formatted;
  };

  const formatTime = timestamp => {
    const time = moment.unix(timestamp);
    const formatted = time.format('hh:mm:ss');
    return formatted;
  };

  switch (coin.symbol) {
    case 'BTC':
      coin.img = {
        src: BTCIcon,
        alt: 'bitcoin logo',
      };
      break;
    case 'LTC':
      coin.img = {
        src: LTCIcon,
        alt: 'litecoin logo',
      };
      break;
    case 'ETH':
      coin.img = {
        src: ETHIcon,
        alt: 'etherium logo',
      };
      break;

    case 'XMR':
      coin.img = {
        src: XMRIcon,
        alt: 'monero logo',
      };
      break;

    case 'XRP':
      coin.img = {
        src: XRPIcon,
        alt: 'ripple logo',
      };
      break;

    case 'EOS':
      coin.img = {
        src: EOSIcon,
        alt: 'EOS logo',
      };
      break;

    default:
      break;
  }

  return (
    <div className="display-box">
      <h3 className="display-box__symbol">{coin.symbol}</h3>
      <img
        src={coin.img.src}
        alt={coin.img.alt}
        className="display-box__icon"
      />
      <span className="display-box__price">
        {`${formatPrice(coin.price)} USD`}
      </span>
      <div className="display-box__date-container">
        <span className="display-box__date">{formatDate(coin.timestamp)}</span>
        <span className="display-box__time">{formatTime(coin.timestamp)}</span>
      </div>
    </div>
  );
};

DisplayBox.propTypes = {
  coin: PropTypes.object.isRequired,
};

export default DisplayBox;
